/**
 * signSelector.js
 * Manages the sign type selection functionality and updates
 * the preview when a different sign type is selected.
 */

class SignSelector {
  constructor(options = {}) {
    // DOM Elements
    this.signOptions = document.querySelectorAll('.sign-option');
    this.signBackgroundImage = document.getElementById('sign-background-image');
    
    // Options with defaults
    this.options = {
      signTypes: options.signTypes || {
        'acrylic-lightbox': 'images/acrylic-lightbox.jpg',
        'metal-sign': 'images/metal-sign.jpg',
        'backlit-acrylic': 'images/backlit-acrylic.jpg'
      },
      defaultSignType: options.defaultSignType || 'acrylic-lightbox'
    };
    
    // State
    this.currentSignType = this.options.defaultSignType;
    this.onSignChangeCallback = options.onSignChange || null;
    
    // Initialize
    this.init();
  }
  
  init() {
    // Set initial sign type
    this.setSignType(this.currentSignType);
    
    // Add click event listeners to sign options
    this.signOptions.forEach(option => {
      option.addEventListener('click', () => {
        const signType = option.dataset.signType;
        this.setSignType(signType);
      });
    });
  }
  
  setSignType(signType) {
    if (!this.options.signTypes[signType]) {
      console.error(`Sign type '${signType}' not found in available options.`);
      return;
    }
    
    // Update current sign type
    this.currentSignType = signType;
    
    // Update active class
    this.signOptions.forEach(option => {
      if (option.dataset.signType === signType) {
        option.classList.add('active');
      } else {
        option.classList.remove('active');
      }
    });
    
    // Change background image
    const imagePath = this.options.signTypes[signType];
    this.signBackgroundImage.src = imagePath;
    
    // Call callback if exists
    if (this.onSignChangeCallback) {
      this.onSignChangeCallback(signType, imagePath);
    }
  }
  
  getCurrentSignType() {
    return this.currentSignType;
  }
  
  getCurrentSignImage() {
    return this.options.signTypes[this.currentSignType];
  }
}

// Export
window.SignSelector = SignSelector;